var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 8C2.25 4.82436 4.82436 2.25 8 2.25C11.1756 2.25 13.75 4.82436 13.75 8C13.75 11.1756 11.1756 13.75 8 13.75C4.82436 13.75 2.25 11.1756 2.25 8ZM8 0.25C3.71979 0.25 0.25 3.71979 0.25 8C0.25 12.2802 3.71979 15.75 8 15.75C12.2802 15.75 15.75 12.2802 15.75 8C15.75 3.71979 12.2802 0.25 8 0.25ZM5 6.34211H6.5C6.5135 5.53495 7.028 4.76316 8 4.76316C8.7155 4.76316 9.5 5.15979 9.5 5.85326C9.5 6.43147 8.90197 6.82721 8.3917 7.16487L8.3 7.22568C7.76075 7.57874 7.331 7.87621 7.25 8.86526V9.5H8.696L8.75 8.94421C8.8715 8.27474 9.3695 7.84274 9.95 7.47895C10.5297 7.10379 11 6.79684 11 5.69411C11 4.81811 10.5507 3.5 8 3.5C6.029 3.5 5.0405 4.71705 5 6.34211ZM8.75 12.5V11H7.25V12.5H8.75Z",
    fill: "#161513"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.25d89f06dc0a46c5feb7c0986b67bc55.svg";
export { ForwardRef as ReactComponent };